import { Box } from "@mui/material";

/**
 * A component to create empty space within a form layout.
 * This can be used for creating gaps or maintaining grid alignment.
 *
 * @param {object} otherProps - Props to pass to the Box component.
 */
const FormBlankField = ({ ...otherProps }) => {
  return <Box {...otherProps} />;
};

FormBlankField.propTypes = {
  // No required props
};

export default FormBlankField;
